import React from "react";
import { StarIcon } from "lucide-react";
import { GMAIL_REVIEWS } from "../data/content";
export function GmailReviews() {
  return <div className="-mx-5" data-id="element-161" data-mp="98xk3agv1nxt">
      <div className="flex snap-x snap-mandatory gap-3 overflow-x-auto px-5 pb-3" style={{
      scrollbarWidth: "none"
    }} aria-label="Reseñas de jugadores, desliza para ver más" data-id="element-162" data-mp="3rd8wbs4m6gbn">
        {GMAIL_REVIEWS.map((r, i) => <article key={i} className="w-[88%] shrink-0 snap-center overflow-hidden rounded-2xl bg-white shadow-lg" data-id="element-163" data-mp="nxleveivttmp" data-mpi={i}>
            <div className="flex items-start gap-3 p-4" data-id="element-164" data-mp="e6qp406fgbwi">
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-base font-semibold text-white" style={{
            backgroundColor: r.color
          }} data-id="element-165" data-mp="e67i3eibf7x9">
                {r.initial}
              </div>
              <div className="min-w-0 flex-1" data-id="element-166" data-mp="1bmmr7cuu5ox9">
                <div className="flex items-center justify-between gap-2" data-id="element-167" data-mp="1bnfozobth439">
                  <p className="truncate text-[14px] font-semibold text-gray-900" data-id="element-168" data-mp="3agjyl136k8jl">
                    {r.name}
                  </p>
                  <span className="shrink-0 text-[11px] text-gray-400" data-id="element-169" data-mp="36c2hj9o7g9ci">
                    {r.time}
                  </span>
                </div>
                <p className="truncate text-[12px] text-gray-500" data-id="element-170" data-mp="3felexe981trd">{r.email}</p>
                <p className="mt-1.5 text-[13px] font-semibold text-gray-900" data-id="element-171" data-mp="3u3hndcf6x8si">
                  {r.subject}
                </p>
                <p className="mt-1 text-[13px] leading-relaxed text-gray-600" data-id="element-172" data-mp="3p3lilayo5dbw">
                  {r.body}
                </p>
                <div className="mt-2 flex gap-0.5" data-id="element-173" data-mp="6y8tcjac9odp">
                  {Array.from({
                length: 5
              }).map((_, s) => <StarIcon key={s} className="h-3.5 w-3.5 fill-amber-400 text-amber-400" data-id="element-174" data-mp="1xum33gkaigq" data-mpi={s} />)}
                </div>
              </div>
            </div>
          </article>)}
      </div>
      <p className="mt-1 text-center text-[11px] text-white/45" data-id="element-175" data-mp="7pqg8bfrn202">Desliza para ver más reseñas →</p>
    </div>;
}